import React from 'react';
import './Contact.css';

const Contact = () => {
    return <section id="contact" className="contact-section">
        <div className="contact-container">
            <div className="section-header">
                <h2>联系我们</h2>
                <p>随时为您提供专业的咨询与服务</p>
            </div>

            {/* 企业信息 */}
            <div className="contact-info-full">
                <div className="info-grid">
                    <div className="info-card">
                        <div className="info-icon">📍</div>
                        <div className="info-content">
                            <h4>公司地址</h4>
                            <p>北京市海淀区安宁庄东路16号2层16-2-26</p>
                            <p className="info-sub">邮编：100020</p>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-icon">📞</div>
                        <div className="info-content">
                            <h4>联系电话</h4>
                            <p className="phone-number">15010433720</p>
                            <p>技术支持1：17600136071</p>
                            <p>技术支持2：18501051518</p>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-icon">📧</div>
                        <div className="info-content">
                            <h4>电子邮箱</h4>
                            <p>商务合作：lianze2008@163.com</p>
                            <p>技术支持：312239109@lanying.com</p>
                            <p>人力资源：hanxianling@lanying.com</p>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-icon">🕒</div>
                        <div className="info-content">
                            <h4>工作时间</h4>
                            <p>周一至周五：09:00 - 18:00</p>
                            <p>周六周日：10:00 - 16:00（值班）</p>
                            <p>24小时紧急技术支持：15010433720</p>
                        </div>
                    </div>
                </div>

                <div className="social-section">
                    <h4>关注我们</h4>
                    <div className="social-icons">
                        <a href="https://www.durker.com/1" className="social-icon" aria-label="微信公众号">
                            <span className="icon">📱</span>
                            <span className="tooltip">公众号：蓝英科技</span>
                        </a>
                        <a href="https://www.durker.com/2" className="social-icon" aria-label="微博">
                            <span className="icon">🐦</span>
                            <span className="tooltip">@蓝英科技官方</span>
                        </a>
                        <a href="https://www.durker.com/3" className="social-icon" aria-label="知乎">
                            <span className="icon">📘</span>
                            <span className="tooltip">蓝英科技专栏</span>
                        </a>
                        <a href="https://www.durker.com/4" className="social-icon" aria-label="LinkedIn">
                            <span className="icon">🔗</span>
                            <span className="tooltip">Lanying Tech</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
}

export default Contact;
